import React, { ButtonHTMLAttributes } from "react";
import { ButtonContainer, ButtonContainerLinked } from "./styles";
import { SystemColosType } from "../../settings/colors";

export interface IPropsButton {
    rounded?: boolean;
    variant: SystemColosType;
    oulined?: boolean;
    linked?: boolean;
    to?: string;
}

interface IProps extends IPropsButton, ButtonHTMLAttributes<any> {
    children: any;
}

const Button = ({
    children,
    rounded = false,
    oulined = false,
    to = "",
    linked = false,
    ...rest
}: IProps) =>
    linked ? (
        <ButtonContainerLinked
            rounded={rounded}
            oulined={oulined}
            to={to}
            {...rest}
        >
            {children}
        </ButtonContainerLinked>
    ) : (
        <ButtonContainer rounded={rounded} oulined={oulined} {...rest}>
            {children}
        </ButtonContainer>
    );

export default React.memo(Button);
